<div *ngIf="permissionData$| async as permissionData">
  <app-bread-crumbs
  [navigationRoute]="currentRoute"
  [currentPageString]="currentPageString"
  [clickHandler]="returnToTagging"
  (buttonActionHandler)="buttonHandler($event)"
  [isReadOnly]="isReadOnly && !permissionData.ability.can('update', permissionData.formTagging)"
  [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage">
</app-bread-crumbs>
</div>

<div class="page-container">
  <app-layout class="container--form">
    <div class="tab-body">
      <div class="section-headers heading-h6-regular">Item Selection</div>
      <form [formGroup]="vendorTaggingForm">
        
          <div class="form-inputs form-dropdown">
              <p>Material sub group filter</p>
              <ng-select
              [items]="MatSGpdropdown"
              appearance="outline"
              bindLabel="value"
              bindValue="id"
              (change)="onMaterialSubGroupChange($event)"
              formControlName="materialSubGroup"
              [(ngModel)]="selectedMaterialSubGroup"
              [readonly]="!isEditable"
              >
              </ng-select>
          </div>
          <div class="form-inputs form-dropdown">
              <p>Item no. and description</p>
              <ng-select
              [items]="itemDescriptionDropdown"
              appearance="outline"
              bindLabel="value"
              bindValue="id"
              (change)="onSelectionItemDescription($event)"
              formControlName="itemSelected"
              [(ngModel)]="selectedItem"
              [readonly]="!isEditable"
              >
              </ng-select>
          </div>

          <div class="list-container" fxLayout="row">    
              <div class="block">
                <div>
                  <div class="tb-header">Details</div>
                  <div class="tb-row">
                    <div class="tb-key">Part/Model no.:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.PartModelNumber}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">COTS/Customised:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.isCOTS}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Item description:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.ItemDescription}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Brand/OEM name:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.BrandOEMName}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Material group:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.MaterialGroupId}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Material sub group:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.MaterialSubGroupId}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Workmanship standard:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.WorkmanshipId}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Criticality code:</div>
                    <div class="tb-value">{{itemDetails.ItemDetails.CriticalityId}}</div>
                  </div>
                </div>
                <div>
                  <div class="tb-header">Price</div>
                  <div class="tb-row">
                    <div class="tb-key">Unit of Measurement (UoM):</div>
                    <div class="tb-value">{{itemDetails.ItemPrice.UnitOfMeasurement}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Quantity</div>
                    <div class="tb-value">{{itemDetails.ItemPrice.Quantity}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Units per quantity (per):</div>
                    <div class="tb-value">{{itemDetails.ItemPrice.UnitsPerQuantity}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Currency</div>
                    <div class="tb-value">{{itemDetails.ItemPrice.Currency}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Estimated unit price:</div>
                    <div class="tb-value">{{itemDetails.ItemPrice.UnitPrice}}</div>
                  </div>
                  <div class="tb-row">
                    <div class="tb-key">Estimated item amount:</div>
                    <div class="tb-value">{{itemDetails.ItemPrice.EstimatedUnitPrice }}</div>
                  </div>
                </div>
              </div>
          </div>

          <div class="section-headers heading-h6-regular">Vendor Selection</div>
          <app-button
              class="budgetBtn"
              icon="add"
              name="Add vendor"
              type="flat-button"
              tabindex="0"
              (keypress)="normalVendorOpen()"
              (click)="normalVendorOpen()"
              [disabled]="!isEditable"
          >
          </app-button>
          <app-button
              class="acslBtn"
              icon="add"
              name="Recommend ACL/ASL"
              type="flat-button"
              tabindex="0"
              (keypress)="aslVendorOpen()"
              (click)="aslVendorOpen()"
              [disabled]="!isEditable"
          >
          </app-button>
          <div
            class="itemvendor-sidenav-container top-padding"
          >
            <mat-sidenav #vendorSearch mode="over" position="end" class="vendor-sidenav">
              <ng-container *ngIf="vendorType == 'normal'">
                <app-vendor-search
                  [vendorActionType]="vendorActionType"
                  [vendorNav]="vendorSearch"
                ></app-vendor-search>
              </ng-container>
              <ng-container *ngIf="vendorType == 'asl'">
                <app-asl-vendor-search [vendorNav]="vendorSearch">
                </app-asl-vendor-search>
              </ng-container>
            </mat-sidenav>
          </div>

          <div class="transfer-list-container" fxLayout="row">
              <mat-grid-list cols="5" rowHeight="2:1">
                  <mat-grid-tile
                      colspan="2"
                      rowspan="3">
                      <mat-card class="transfer-list">
                          <mat-selection-list #availableList (selectionChange)="onLeftSelection(availableList.selectedOptions.selected)">
                              <div class="transfer-list-header" mat-subheader>
                                <mat-checkbox formControlName="isExistingVendorsChecked" tabindex='0' (keypress)="selectAllAvailable()" (click)="selectAllAvailable()" [(ngModel)]="isAllExistingVendorsChecked"></mat-checkbox>
                                List of existing vendors</div>
                              <mat-list-option [disabled]="!isEditable" *ngFor="let vendor of mappedVendors" [value]="vendor.VendorNumber">
                              <span class="no-wrap">{{vendor.Name}}</span>
                              </mat-list-option>
                          </mat-selection-list>
                      </mat-card>
                  </mat-grid-tile>

                  <mat-grid-tile
                      colspan="1"
                      rowspan="2" style="width: 100%; height: 100%;">
                      <div class="action-buttons" fxLayout="column">
                        <button class="transfer-btn" mat-button [disabled]="!isEditable" (click)="transferAllToRight()"><mat-icon>keyboard_double_arrow_right</mat-icon></button>
                        <button class="transfer-btn" mat-button [disabled]="!isEditable" (click)="transferRight()"><mat-icon>chevron_right</mat-icon></button>
                        <button class="transfer-btn" mat-button [disabled]="!isEditable" (click)="transfeLeft()"><mat-icon>chevron_left</mat-icon></button>
                        <button class="transfer-btn" mat-button [disabled]="!isEditable" (click)="transferAllToLeft()"><mat-icon>keyboard_double_arrow_left</mat-icon></button>
                      </div>
                  </mat-grid-tile>

                  <mat-grid-tile
                      colspan="2"
                      rowspan="3">
                      <mat-card class="transfer-list">
                          <mat-selection-list #selectedList (selectionChange)="onRightSelection(selectedList.selectedOptions.selected)">
                              <div class="transfer-list-header" mat-subheader>
                                <mat-checkbox formControlName="isTaggedVendorsChecked" tabindex="0" (keypress)="selectAllTagged()" (click)="selectAllTagged()" [(ngModel)]="isAllTaggedVendorsChecked"></mat-checkbox>
                                List of vendors tagged</div>
                              <mat-list-option [disabled]="!isEditable" *ngFor="let vendor of listOfTaggedVendors" [value]="vendor.VendorNumber">
                              <span class="no-wrap">{{vendor.Name}}</span>
                              </mat-list-option>
                          </mat-selection-list>
                      </mat-card>
                  </mat-grid-tile>
              </mat-grid-list>
          </div>
          <div class="form-inputs form-dropdown">
              <p>
              Sourcing status
              <span
                  class="required"
                  >*</span
              >
              </p>
              <div class="CritCodedropdown-tooltip">
              <ng-select
                  [items]="sourcingStatus"
                  appearance="outline"
                  bindValue="SourcingStatusId"
                  bindLabel="name"
                  dropdownPosition="top"
                  formControlName="sourcingStatus"
                  [(ngModel)]="sourcingStatusId"
                  [readonly]="!isEditable"
              >
              </ng-select>
              </div>
          </div>
      </form>
    </div>
  </app-layout>
</div>
